import { render } from "./EditCatalogModal.vue?vue&type=template&id=70c2bf68&scoped=true"
import script from "./EditCatalogModal.vue?vue&type=script&lang=js"
export * from "./EditCatalogModal.vue?vue&type=script&lang=js"

import "./EditCatalogModal.vue?vue&type=style&index=0&id=70c2bf68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2bf68"]])

export default __exports__